import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDeleteTask } from '../api/tasks.api';

export function useDeleteTask(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (taskId: string) => apiDeleteTask(projectId, taskId),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['tasks', projectId] }),
    });
}
